import React from 'react';
import { NavLink } from 'react-router-dom';

/**
 * Sub-navigation tabs shown at the top of every Stocks / Crypto sub-page
 * (Overview, Heatmap, Fear & Greed). Routes are passed in by the caller so
 * the same component serves both workspaces.
 */
export default function WorkspaceTabs({ tabs }) {
  return (
    <nav style={s.bar}>
      {tabs.map(t => (
        <NavLink
          key={t.to}
          to={t.to}
          end={t.end ?? false}
          style={({ isActive }) => ({
            ...s.tab,
            ...(isActive ? s.tabActive : {}),
          })}
        >
          {t.label}
        </NavLink>
      ))}
    </nav>
  );
}

const s = {
  bar: {
    display: 'flex',
    gap: '4px',
    marginBottom: '20px',
    background: 'var(--surface)',
    border: '1px solid var(--border)',
    borderRadius: '12px',
    padding: '4px',
    overflowX: 'auto',
    width: 'fit-content',
    maxWidth: '100%',
  },
  tab: {
    padding: '8px 16px',
    borderRadius: '8px',
    fontSize: '13px',
    fontWeight: 700,
    color: 'var(--text-secondary)',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    transition: 'background 0.12s, color 0.12s',
  },
  tabActive: {
    background: '#4f46e5',
    color: '#fff',
  },
};
